import { render, staticRenderFns } from "./Planer.vue?vue&type=template&id=3a65b822&"
import script from "./Planer.vue?vue&type=script&lang=js&"
export * from "./Planer.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports